import React from 'react';
import { faCheckCircle, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { Button } from './button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const InformationModal = ({
    modalText,
    close,
    setModalClose,
    navigate,
}) => {
    return (
        <div className='fixed top-0 left-0 min-h-screen w-screen flex justify-center items-center bg-backgrounds-slate bg-opacity-20 z-50 backdrop-filter backdrop-blur-sm'>
            <div className='w-1/4 min-w-[500px] max-w-[40vw] relative bg-backgrounds-slate p-4 rounded-xl shadow-lg flex-col items-center border sm:mx-2'>
                <div className='pb-4 font-semibold text-texts-tertiary'>
                    <FontAwesomeIcon icon={faInfoCircle} className='mr-2' />
                    Information
                </div>

                <div className='flex items-center justify-center w-full mb-4 p-4 border rounded-xl bg-backgrounds-white h-auto'>
                    <div className='text-base font-semibold text-texts-secondary300 break-words'>
                        {modalText}
                    </div>
                </div>

                <div className='flex justify-center w-full'>
                    <Button
                        className='w-[120px]'
                        type={'success'}
                        onClick={() => {
                            if (close) {
                                setModalClose(false);
                            } else {
                                navigate(0); // Refreshes the page
                            }
                        }}
                        icon={faCheckCircle}
                        text={'OK'}
                        hoverText={'Refresh the page'}
                    />
                </div>
            </div>
        </div>
    );
};
